    <div class="input-column">
        <table>
          <tr>
            <td><label>Customer Site Name</label></td>
            <td> <input type="text"[attr.disabled]="hideSaveOption ? '' : null"  [(ngModel)]="company.name" /></td>
          </tr>
          <tr>
            <td><label>Customer Account Number</label></td>
            <td><input type="text"[attr.disabled]="hideSaveOption ? '' : null"  [(ngModel)]="company.account_Number" /></td>
          </tr>
          <tr>
            <td><label>Address Line 1</label></td>
            <td> <input type="text"[attr.disabled]="hideSaveOption ? '' : null"  [(ngModel)]="company.address_1" /></td>
          </tr>

          <tr>
            <td><label>Address Line 2</label></td>
            <td> <input type="text"[attr.disabled]="hideSaveOption ? '' : null"  [(ngModel)]="company.address_2" /></td>
          </tr>
          <tr>
            <td><label>Address Line 3</label></td>
            <td> <input type="text"[attr.disabled]="hideSaveOption ? '' : null"  [(ngModel)]="company.address_3" /></td>
          </tr>
          <tr>
            <td><label>Address Line 4</label></td>
            <td> <input type="text"[attr.disabled]="hideSaveOption ? '' : null"  [(ngModel)]="company.address_4" /></td>
          </tr>
          <tr>
            <td><label>Postcode</label></td>
            <td> <input type="text"[attr.disabled]="hideSaveOption ? '' : null"  [(ngModel)]="company.postcode" /></td>
          </tr>

          <tr>
            <td><label>Contact Name</label></td>
            <td> <input type="text"[attr.disabled]="hideSaveOption ? '' : null"  [(ngModel)]="company.contact_Name" /></td>
          </tr>

          <tr>
            <td><label>Contact Phone</label></td>
            <td> <input type="text"[attr.disabled]="hideSaveOption ? '' : null"  [(ngModel)]="company.contact_Phone" /></td>
          </tr>
          <tr>
            <td><label>Contact Email</label></td>
            <td> <input type="text"[attr.disabled]="hideSaveOption ? '' : null"  [(ngModel)]="company.contact_Email" /></td>
          </tr>
          <tr *ngIf="!hideSaveOption">
            <td><label>Expired</label></td>
            <td> <input type="checkbox" id="switch-1" name="switch-1" role="switch" [(ngModel)]="company.expired" />
            </td>
          </tr>
          <tr *ngIf="company.id == null || company.id == undefined || company.id == ''" style="margin-top:1rem">
            <td><label>Add a location with the same details?</label></td>
            <td> <input type="checkbox" id="switch-1" name="switch-1" role="switch" [(ngModel)]="company.addLocation" />
            </td>
          </tr>

        </table>
      </div>